import { Components, Theme } from '@mui/material';

const MuiDialogContent: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(
        0,
        theme.spacingSizes.lg,
        theme.spacingSizes.xxxl,
        theme.spacingSizes.lg,
      ),
    }),
  },
};

export default MuiDialogContent;
